import { useTranslation } from 'react-i18next';

/** Title and summary of a guide from the HelpGuide namespace. */
export function useGuideText(): {
  title: (id: string) => string;
  summary: (id: string) => string;
} {
  const { t } = useTranslation('HelpGuide');
  return {
    title: (id) => t(`guide.${id}.title`),
    summary: (id) => t(`guide.${id}.summary`),
  };
}
